import React from "react";
import { makeStyles } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Button from "@material-ui/core/Button";
import AvcReport from "../../../assets/img/avc_report.svg";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#FFF",
    padding: "8px 12px",
    borderRadius: 50,
    minHeight: "90vh",
  },
  title: {
    margin: 0,
  },
  dis: {
    fontSize: 14,
    color: "#6F6F6F",
  },
  skipbtn: {
    fontSize: 12,
    color: "#101010",
    border: "1px solid #E0E0E0",
    borderRadius: 8,
  },
  accbtn: {
    backgroundColor: "#0071F2",
    fontSize: 12,
    borderRadius: 8,
    "&:hover": {
      backgroundColor: "#0071F2",
    },
  },
  climeDiv: {
    display: "flex",
    backgroundColor: "#ECF9FF",
    border: "1px solid #C1E1F3",
    padding: "14px 12px",
    borderRadius: 8,
    marginBottom: "2%",
  },
  climeTitle: {
    margin: 0,
    color: "#2F9CD8",
    fontSize: 14,
  },
  climeDis: {
    color: "#6DBAE4",
    fontSize: 12,
    padding: 0,
    margin: 0,
  },
  checkStatement: {
    "& .MuiTypography-body1": {
      fontSize: 14,
    },
  },
}));
const GreenCheckbox = withStyles({
  root: {
    color: "#36A2EB",
    "&$checked": {
      color: "#36A2EB",
    },
  },
})((props) => <Checkbox color="default" {...props} />);
export function AcceptanceEref(props) {
  const classes = useStyles();
  const [state, setState] = React.useState({
    checkedB: true,
  });

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const accept = () => {
    props?.proceed && props.proceed();
  };

  return (
    <div className={classes.root}>
      <div className={classes.climeDiv}>
        <img src={AvcReport} />
        <div style={{ marginLeft: "2%" }}>
          <h5 className={classes.climeTitle}>Consultation Consent Form</h5>
          <p className={classes.climeDis}>
            We request you to read and understand the consent form and its
            purpose. Then acknowledging the consent form only allow you to
            proceed with the further steps for this consultation.
          </p>
        </div>
      </div>
      <h4 className={classes.title}>Consent form of Aniqa Hospital</h4>
      <p className={classes.dis}>
        <h5 className={classes.title}>Purpose of Consent</h5>
        <br />
        I, the undersigned, hereby authorize to share my medical records, test
        results, imaging, and other relevant healthcare information for the
        purpose of facilitating further diagnosis, treatment, or specialized
        care as outlined in the referral letter.
        <br />
        <br />
        <h5 className={classes.title}> Details of Information to Be Shared</h5>
        <br />
        The information to be shared may include, but is not limited to:
        <br />
        <ol className={classes.ul}>
          <li>Medical history, diagnosis, and treatment notes.</li>
          <li>
            Laboratory test results and imaging studies (e.g., X-rays, MRIs, CT
            scans).
          </li>
          <li>Current medications and treatment plans.</li>
          <li>Referral letter and relevant supporting documentation.</li>
        </ol>
        <br />
        <h5 className={classes.title}> Conditions of Sharing</h5>
        <ol>
          <li>
            The information will only be shared with the above-mentioned
            healthcare provider(s).
          </li>
          All information will be transmitted securely in compliance with
          privacy laws, including [applicable regulations, e.g., HIPAA].
          <li>
            This consent will remain valid until the completion of my treatment
            or until [insert expiration date], unless revoked in writing by me.
          </li>
        </ol>
        <h5 className={classes.title}>Patient Rights</h5>
        <ul>
          <li>
            {" "}
            I understand that I have the right to withdraw my consent at any
            time by providing written notice to hospital.
          </li>
          <li>
            I understand that refusing to give consent may impact the continuity
            or quality of my care.
          </li>
          <li>
            I understand that I am entitled to request a copy of this consent
            form.
          </li>
        </ul>
      </p>
      <div style={{ textAlign: "center", color: "gray" }}>
        <FormControlLabel
          control={
            <GreenCheckbox
              checked={state.checkedG}
              onChange={handleChange}
              name="checkedG"
            />
          }
          className={classes.checkStatement}
          label="By signing below, I confirm that I understand and agree to the terms outlined above."
        />
        <div style={{ marginTop: "1%", marginBottom: "1%" }}>
          <Button
            variant="contained"
            color="primary"
            className={classes.accbtn}
            onClick={accept}
          >
            Accept Consent
          </Button>
          {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Button onClick={accept} variant="outlined" className={classes.skipbtn}>
                        Skip For Now
                    </Button> */}
        </div>
      </div>
    </div>
  );
}
